"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginTemplates = void 0;
var React = require("react");
var moment = require("moment");
var react_router_dom_1 = require("react-router-dom");
var services_1 = require("@falcon/services");
var Header_1 = require("./navigator/Header");
var Footer_1 = require("./navigator/Footer");
var PluginTemplates = exports.PluginTemplates = /** @class */ (function () {
    function PluginTemplates() {
        var _this = this;
        this.renderBackButton = function (link) {
            return link ?
                React.createElement(react_router_dom_1.Link, { to: link, className: "no-underline" },
                    React.createElement("button", { type: "button", className: "btn btn-back plugin" }, "Back")) :
                React.createElement("a", { onClick: _this.goBack, className: "no-underline" },
                    React.createElement("button", { type: "button", className: "btn btn-back plugin" }, "Back"));
        };
        this.setPageTitle = function (pageTitle) {
            document.title = pageTitle;
            window.LvDataLayer = {
                pageTitle: pageTitle
            };
        };
        this.renderHeader = function () {
            return (React.createElement(Header_1.Header, null));
        };
        this.renderFooter = function () { return (React.createElement(Footer_1.Footer, null)); };
    }
    PluginTemplates.prototype.renderBackLink = function (buttonName, isTop, link) {
        if (link) {
            return (React.createElement("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom") },
                React.createElement(react_router_dom_1.Link, { to: link },
                    React.createElement("button", { type: "button", role: "link", className: "btn btn-back-link" }, buttonName))));
        }
        return (React.createElement("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom") },
            React.createElement("a", { onClick: this.goBack },
                React.createElement("button", { type: "button", role: "link", className: "btn btn-back-link" }, buttonName))));
    };
    PluginTemplates.prototype.renderBackReloadLink = function (buttonName, isTop, link) {
        return (React.createElement("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom") },
            React.createElement("a", { href: "javascript:void(0)", onClick: this.navigateTo(link) },
                React.createElement("button", { type: "button", className: "btn btn-back-link" }, buttonName))));
    };
    PluginTemplates.prototype.goBack = function (event) {
        event.target.href = window.history.back();
    };
    PluginTemplates.prototype.navigateTo = function (link) {
        return function () {
            window.location.href = link;
        };
    };
    PluginTemplates.convertDate = function (inputDate, format) {
        var valueAsMoment = moment(inputDate, moment.ISO_8601);
        if (valueAsMoment.isValid()) {
            return (valueAsMoment.format(format));
        }
        return null;
    };
    PluginTemplates.getOrdinal = function (num) {
        var suffixes = ["th", "st", "nd", "rd"];
        var numberEnding = num % 100;
        return num + (suffixes[(numberEnding - 20) % 10] || suffixes[numberEnding] || suffixes[0]);
    };
    PluginTemplates.convertDateUTC = function (inputDate, format) {
        var valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
        if (valueAsMoment.isValid()) {
            return (valueAsMoment.format(format));
        }
        return null;
    };
    PluginTemplates.getItemWordings = function (product, type) {
        var title = "";
        var description = "";
        if (product === services_1.ProductNameEnum.RENTERS) {
            switch (type) {
                case services_1.ValuableItemTypeEnum.MOBILE:
                    title = "Mobile phone";
                    description = "(e.g iPhone X, 250GB)";
                    break;
                case services_1.ValuableItemTypeEnum.BIKE:
                    title = "Bicycle";
                    description = "(e.g Giant, road bike)";
                    break;
                case services_1.ValuableItemTypeEnum.LAPTOP:
                    title = "Laptop";
                    break;
                case services_1.ValuableItemTypeEnum.COMPUTER:
                    title = "Computer / accessories";
                    break;
                case services_1.ValuableItemTypeEnum.TABLET:
                    title = "Tablet";
                    break;
                case services_1.ValuableItemTypeEnum.TV:
                    title = "TV & Hi-Fi";
                    break;
                case services_1.ValuableItemTypeEnum.CAMERA:
                    title = "Camera / accessories";
                    description = "(e.g Nikon DSLR D7500)";
                    break;
                case services_1.ValuableItemTypeEnum.JEWELLERY:
                    title = "Jewellery (incl.watches)";
                    description = "(e.g Tiffany necklace / Rolex watch)";
                    break;
                case services_1.ValuableItemTypeEnum.SPORT:
                    title = "Sport / leisure equipment";
                    description = "(e.g Burton Mystery snowboard)";
                    break;
                case services_1.ValuableItemTypeEnum.HEARING:
                    title = "Hearing aid";
                    description = "(e.g HD 500 Digital Hearing Aid)";
                    break;
                case services_1.ValuableItemTypeEnum.WHEELCHAIR:
                    title = "Wheelchair";
                    break;
                case services_1.ValuableItemTypeEnum.MUSIC:
                    title = "Musical instrument";
                    description = "(e.g Gibson Guitar Les Paul Standard '50s)";
                    break;
                case services_1.ValuableItemTypeEnum.HEADPHONES:
                    title = "Headphones";
                    break;
            }
        }
        return { title: title, description: description };
    };
    return PluginTemplates;
}());
//# sourceMappingURL=PluginTemplates.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/PluginTemplates.js
// module id = 1073
// module chunks = 0